import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPreguntaActiva, setRespuesta } from "../actions";

// 1. Importamos Spinner y Alert
import { Container, Row, Col, Button, Spinner, Alert } from "react-bootstrap";

import { Instrumento } from "./Instrumento";
import check from "../img/check-svgrepo-com.svg";

const obtenerSiguientePregunta = (todasLasPreguntas, respuestasActuales) => {
  const preguntasPendientes = todasLasPreguntas.filter(
    (pregunta) =>
      !respuestasActuales.some((r) => r.id_pregunta === pregunta.id_pregunta)
  );
  if (preguntasPendientes.length === 0) {
    return null;
  }
  const randomIndex = Math.floor(Math.random() * preguntasPendientes.length);
  return preguntasPendientes[randomIndex].id_pregunta;
};

const Pregunta208 = (props) => {
  const dispatch = useDispatch();

  // Estado para controlar el bloqueo del botón y mensajes de error
  const [isSaving, setIsSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState(""); // <--- Nuevo estado para errores visuales

  const [values, setValues] = useState({
    usted: 0,
  });

  const preguntaActiva = useSelector((state) => state.preguntaActiva);
  const ticket = useSelector((state) => state.ticket);

  //console.log("Pregunta Activa Estado:", preguntaActiva);

  // Proceso de volver al inicio
  const HandleClickVolver = () => {
    dispatch(
      setPreguntaActiva({
        id_instrumento: 0,
        id_pregunta: 0,
        contador: 0,
        pregunta_anterior: 0,
        respuesta_anterior: 0,
        //respuestas208: [], // Es bueno resetear si vuelves al inicio
      })
    );
    setValues((values) => ({ ...values }));
  };

  // Si no hay instrumento activo volver al inicio
  if (preguntaActiva.id_instrumento === 0)
    return <Navigate to="/inicio" replace={true} />;

  // Buscar el instrumento activo
  const _instrumento = Instrumento.find((element) => {
    return element.id_instrumento === preguntaActiva.id_instrumento;
  });

  // Buscar la pregunta activa
  const _preg = _instrumento.preguntas.find((element) => {
    return element.id_pregunta === preguntaActiva.id_pregunta;
  });

  // Proceso de avanzar
  const HandleClickSiguiente = async () => {
    setIsSaving(true);
    setErrorMsg(""); // Limpiamos errores previos

    try {
      const _respuesta = {
        id_pregunta: preguntaActiva.id_pregunta,
        respuesta: values.usted,
      };

      const _props = {
        token: "c3649ba4e3a81815",
        function: "SetRespuesta",
        params: {
          ticket: ticket.Ticket,
          id_proceso: 1,
          id_usuario: ticket.id_usuario,
          id_pregunta: preguntaActiva.id_pregunta,
          respuesta: values.usted,
          respuesta_texto: "",
          respuesta_2: 0,
          respuesta_texto_2: "",
          respuesta_3: 0,
          respuesta_texto_3: "",
        },
      };

      // ESPERAMOS LA RESPUESTA
      await dispatch(setRespuesta(_props));

      // --- CÁLCULO DE SIGUIENTE PREGUNTA ---
      // Usamos un fallback por seguridad por si respuestas208 es undefined
      const currentRespuestas = preguntaActiva.respuestas208 || [];

      const existingIndex = currentRespuestas.findIndex(
        (item) => item.id_pregunta === _respuesta.id_pregunta
      );

      let updatedRespuestas;

      if (existingIndex >= 0) {
        updatedRespuestas = currentRespuestas.map((item, index) =>
          item.id_pregunta === _respuesta.id_pregunta
            ? { ...item, ..._respuesta }
            : item
        );
      } else {
        updatedRespuestas = [...currentRespuestas, _respuesta];
      }

      // Randomizar
      const idSiguiente = obtenerSiguientePregunta(
        _instrumento.preguntas,
        updatedRespuestas
      );

      // Si ya no hay preguntas (idSiguiente es null), mantenemos el actual para no romper render,
      // el contador hará que se muestre "Fin de Test"
      const nextId =
        idSiguiente !== null ? idSiguiente : preguntaActiva.id_pregunta;

      dispatch(
        setPreguntaActiva({
          id_instrumento: preguntaActiva.id_instrumento,
          id_pregunta: nextId,
          contador: preguntaActiva.contador + 1,
          pregunta_anterior: preguntaActiva.id_pregunta,
          respuesta_anterior: values.usted,
          respuestas208: updatedRespuestas,
        })
      );

      setValues((values) => ({ ...values, usted: 0 }));
    } catch (error) {
      console.error(error);
      // Mostramos mensaje en la UI en lugar de alert()
      setErrorMsg("Error de conexión. Por favor intente nuevamente.");
    } finally {
      setIsSaving(false);
    }
  };

  const HandleClick1 = (val) => {
    setValues((prev) => ({ ...prev, usted: val }));
    // Opcional: Si cambian la respuesta, ocultamos el error
    if (errorMsg) setErrorMsg("");
  };

  // Mostrar Fin de Test
  // Agregamos chequeo de seguridad if(!_preg)
  if (_instrumento.total_preguntas < preguntaActiva.contador || !_preg)
    return (
      <Container>
        <h1 className="mt-4">Fin de Test</h1>
        <hr />
        <Row>
          <Col>
            <p className="xz-texto-v ">Has finalizado este test.</p>
            <p className="xz-texto-v ">Sigue adelante !</p>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* Quitamos .bind(this) */}
            <Button className="xz-btn-pregunta" onClick={HandleClickVolver}>
              Volver al Inicio
            </Button>
          </Col>
        </Row>
      </Container>
    );

  const es_un_check_usted = (i) => {
    if (values.usted === i) return <img alt="" src={check} width="50" />;
  };

  const avanzar_siguiente = () => {
    // Ajuste lógico: si contador es > 0 y se seleccionó una opción
    if (values.usted > 0) {
      return (
        <Col className="text-end">
          {/* BOTÓN CON SPINNER */}
          <Button onClick={HandleClickSiguiente} disabled={isSaving}>
            {isSaving ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                Guardando...
              </>
            ) : (
              "Avanzar a Siguiente Pregunta"
            )}
          </Button>
        </Col>
      );
    }
  };

  const pregunta_final = () => {
    return (
      <Row>
        <hr />
        <p className="xz-texto-instruccion ">
          Escoja la afirmación que mejor defina su comportamiento habitual
          <span className="xz-texto-instruccion-enfasis"> EN SU TRABAJO</span>.
        </p>
        <p className="xz-texto-instruccion">
          No hay alternativa correcta porque cada uno/a es como es en
          determinados asuntos.
        </p>

        <Col>
          <Row>
            <Col className="ms-5 mb-5 xz-texto-instruccion">
              <p></p>
            </Col>
          </Row>
          <Row className="mb-5 ">
            <Col className="col-4 d-flex justify-content-end">
              {/* Uso de arrow function en vez de bind */}
              <Button
                className="xz-btn-pregunta-3"
                onClick={() => HandleClick1(1)}
              >
                {es_un_check_usted(1)}
              </Button>
            </Col>
            <Col className="col-8 d-flex justify-content-start align-items-center">
              <p className="xz-titulo1 ">{_preg.alt1}</p>
            </Col>
          </Row>
          <Row>
            <Col className="col-4 d-flex justify-content-end">
              <Button
                className="xz-btn-pregunta-3"
                onClick={() => HandleClick1(2)}
              >
                {es_un_check_usted(2)}
              </Button>
            </Col>
            <Col className="col-8 d-flex justify-content-start align-items-center">
              <p className="xz-titulo1 ">{_preg.alt2}</p>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <Container>
      <Row>
        <Col>
          <h3 className="mt-4 xz-titulo1">
            Pregunta {preguntaActiva.contador} de {_instrumento.total_preguntas}
          </h3>
        </Col>
        <Col>
          <h3 className="mt-4 xz-titulo2 text-end">
            {_instrumento.nombre_instrumento}
          </h3>
        </Col>
      </Row>

      <hr />
      {pregunta_final()}
      <hr className="mt-5" />

      {/* ZONA DE ERROR VISUAL */}
      {errorMsg && (
        <Row>
          <Col>
            <Alert variant="danger">{errorMsg}</Alert>
          </Col>
        </Row>
      )}

      <Row>
        <Col className="text-start">
          {/* Cambiado a span con estilo para evitar warning de <a> sin href */}
          <span
            className="xz-texto-nota"
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={HandleClickVolver}
          >
            Volver al Inicio
          </span>
        </Col>
        <Col>
          <p className="xz-texto-nota ">{avanzar_siguiente()}</p>
        </Col>
      </Row>
    </Container>
  );
};

export default Pregunta208;
